<div class="main-container" *ngIf="!isStandalonePage">
  <mat-toolbar class="top-navbar">
    <div class="logo"></div>
    <div class="brand">
      <span class="brand-text">Intelligence</span>
    </div>
    <ng-container *ngIf="loginDisplay">
      <div class="nav-buttons">
        <button mat-button [routerLink]="'home'">Home</button>
        <button mat-button [routerLink]="'dashboards'">Dashboards</button>
        <button mat-button *ngIf="userService.IsInRole('B29 Internal Dashboard - Access')" [routerLink]="'internalb29'">Internal - B-29</button>
        <button mat-button *ngIf="userService.IsInRole('GroupMe Dashboard - B29 Access')" [routerLink]="'groupme-chat'">Chat</button>
        <button mat-button *ngIf="userService.IsInRole('Telerik Report View')" [routerLink]="'telerik-reporting'">Reporting</button>
        <button mat-button [routerLink]="'maintenance'">Maintenance</button>
      </div>
    </ng-container>
    <div class="toolbar-spacer"></div>
    <a *ngIf="loginDisplay" mat-button [routerLink]="['identity/profile']">Hello {{userName}}!</a>
    <button mat-button *ngIf="!loginDisplay" (click)="login()">Login</button>
    <button mat-button *ngIf="loginDisplay" (click)="logout()">Log off</button>

  </mat-toolbar>

  <mat-sidenav-container>
    <mat-sidenav #sidenavElement
                 mode="side"
                 position="start"
                 [opened]="true"
                 [ngClass]="isSidenavOpen ? 'sidenav-expanded' : 'sidenav-collapsed'"
                 class="sidenav"
                 disableClose
                 (transitionend)="onSidenavTransitionEnd()">
      <button mat-icon-button
              class="sidenav-toggle-btn"
              (click)="toggleSidenav()"
              [attr.aria-label]="isSidenavOpen ? 'Collapse sidenav' : 'Expand sidenav'">
        <mat-icon>
          {{ isSidenavOpen ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}
        </mat-icon>
      </button>

      <div class="sidenav-content-fade" [class.sidenav-content-hidden]="!isSidenavOpen">
        <ng-container *ngIf="isSidenavOpen">
          <ng-container>
            <div class="site-header">
              <h2>Site</h2>
            </div>
            <mat-form-field appearance="outline" class="site-select">
              <mat-select [value]="siteId" (selectionChange)="siteChange($event)">
                <mat-option *ngFor="let site of siteItems" [value]="site.id">{{site.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <!--Menu items from the loaded module-->
          <mat-nav-list>
            <mat-list-item *ngFor="let item of menuItems" [routerLink]="item.path"
                           [queryParams]="item.data?.['queryParams']" [class]="item.data?.['customClass']">
              <div class="nav-item-container">
                <button *ngIf="item.data?.['queryParams']?.additionalAction"
                        [routerLink]="item.data?.['queryParams']?.additionalAction.path"
                        class="nav-button"
                        (click)="$event.stopPropagation()">
                  <span [class]="item.data?.['queryParams']?.additionalAction.icon"></span>
                </button>
                <span *ngIf="item.data?.['icon']" [class]="item.data?.['icon']" style="color: white; margin-right: 8px;"></span>
                <span class="nav-list">{{item.title}}</span>
                <span style="flex: 1"></span>
              </div>
            </mat-list-item>
          </mat-nav-list>
          <div sideNavContainer></div>
        </ng-container>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <footer class="footer-internal">
    <div class="footer-content-internal">
      <p>Powered By:</p>
      <div class="footer-logo-internal"></div>
      <p>Intelligence</p>
    </div>
  </footer>
</div>

<div *ngIf="isStandalonePage" class="standalone-container">
  <router-outlet></router-outlet>
</div>

<div kendoDialogContainer></div>
<app-grid-context-menu></app-grid-context-menu>
